import React, { Component } from "react";
import { Image } from "react-bootstrap";
import StarRatings from "react-star-ratings";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import { RestaurantGridCardStyled } from "./style";

// Component
import Color from "../../assets/color";
import Icon from "../../components/Icon";
import Link from "../../components/Link";

// Helper
import { _renderRestaurantProfilePic } from "../../helpers/Utility";

class RestaurantGridCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  _goToRestaurantDetail = (id) => {
    this.props.history.push(`/restaurant/?restaurant=${id}`);
  };

  _onDelete = (e) => {
    e.preventDefault();
    this.props.onDelete();
  };

  _imageOnError = (event) => {
    event.target.setAttribute(
      "src",
      require("./../../assets/img/lolol-bg-white.png")
    );
  };

  render() {
    const { restaurantDetail, isEditing } = this.props;

    /* Food Preference String */
    let restaurantFoodPreference = ["halal", "vegetarian", "pork_free"];
    // let restaurantFoodPreferenceString = ["Halal", "Vegetarian", "No Pork"];
    let restaurantFoodPreferenceString = [
      "Halal",
      "Vegetarian",
      "Muslim Friendly",
    ];

    let countFoodPreference = 0;
    let foodPreferenceString = "";
    restaurantFoodPreference.forEach((type, index) => {
      if (restaurantDetail.RestaurantSetting[type] === true) {
        foodPreferenceString +=
          countFoodPreference > 0
            ? " / " + restaurantFoodPreferenceString[index]
            : restaurantFoodPreferenceString[index];
        countFoodPreference++;
      }
    });
    /* END Food Preference String */

    return (
      <RestaurantGridCardStyled className="grid-card">
        <Link
          className="restaurant-list-card"
          to={`/restaurant/?restaurant=${restaurantDetail.restaurant_id}`}
        >
          <div className="wrapper">
            {/* Checkbox */}
            {/* isEditing && (
            <Form>
              <Form.Check
                custom
                type="checkbox"
                name="restaurant-checkbox"
                className="mb-2"
                label=""
                checked={isSelected}
                id={`custom-edit-bookmark-${restaurantDetail.restaurant_id}`}
                value={restaurantDetail.restaurant_id}
                onChange={this.props.handleChange}
              />
            </Form>
          ) */}
            {/* END Checkbox */}
            {isEditing && (
              <div
                className="delete clickable"
                onClick={(e) => this._onDelete(e)}
              >
                <Icon
                  type="font-awesome"
                  name="trash"
                  size={24}
                  color={Color.razz}
                />
              </div>
            )}
            <div className="image">
              <Image
                src={_renderRestaurantProfilePic(restaurantDetail.Media)}
                onError={this._imageOnError}
              />
            </div>
            <div className="information">
              <h3>{restaurantDetail.restaurant_name}</h3>
              <p className="preference-text">
                <i>{foodPreferenceString}</i>
              </p>
              <div className="rating">
                <StarRatings
                  rating={JSON.parse(restaurantDetail.avg_rating)}
                  starRatedColor={Color.primary}
                  starEmptyColor={Color.athens}
                  starDimension="15px"
                  starSpacing="1px"
                />

                <span>{restaurantDetail.total_vote} Reviews</span>
              </div>
              <p className="state">{restaurantDetail.restaurant_state}</p>
              {/*  <div className="category">
                {restaurantDetail.category.map((data, index) => {
                  return (
                    <div className="category-item" key={index}>
                      <Icon
                        type="font-awesome"
                        name="circle"
                        size={4}
                        color={Color.emperor}
                      />
                      <span className="label">{data}</span>
                    </div>
                  );
                })}
              </div> */}
            </div>
          </div>
        </Link>
      </RestaurantGridCardStyled>
    );
  }
}

RestaurantGridCard.propTypes = {
  restaurantDetail: PropTypes.object.isRequired,
};

export default withRouter(RestaurantGridCard);
